import { MODAL } from 'admin/constants/common';
import { ModalReducerState } from 'admin/reducers/modal-reducer';

export function withModalToShow(modal: ModalReducerState<MODAL>) {
	return {
		modalToShow: modal,
	};
}

interface WithModalToShow {
	modalToShow: ModalReducerState<MODAL>;
}

export function hasModalToShow(state: unknown): state is WithModalToShow {
	return (
		(state as WithModalToShow)?.modalToShow !== undefined &&
		Object.values(MODAL).some(id => id === (state as WithModalToShow)?.modalToShow?.id)
	);
}
